import { connect } from 'react-redux';
import MobileDataTable from '../components/web_mobile/mobile_components/MobileDataTable';

const mapStateToProps = (state) => ({
  mobileSettingDataTable: state.mobileSettingDataTable,
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(MobileDataTable);
